(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ContributionDialogController', ContributionDialogController);

    ContributionDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', 'Principal'];

    function ContributionDialogController ($timeout, $scope, $state, $stateParams, $uibModalInstance, Principal) {
        var vm = this;
        vm.isAdmin = isAdmin;
        $timeout(function (){
            if ($stateParams.multiple){
                vm.multiple = true;
                vm.selectedContribution = 'new-profile';
                $state.go($state.current.parent + '.' + vm.selectedContribution);
            } else {
                vm.multiple = false;
            }
        });
        console.log($stateParams);
        
        $scope.options = [
          { label: 'Une nouvelle personne', value: 'new-profile' },
          { label: 'Une nouvelle entreprise', value: 'new-company' },
          { label: 'Une nouvelle collectivité', value: 'new-collectivity' }
        ];
       
        vm.change = function() {
            $state.go($state.current.parent + '.' + vm.selectedContribution);
        };


        function clear () {
            $uibModalInstance.close();
        }

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }
    }
})();
